import { getFileExtension } from './assetUrls'

const BYTES_PER_MEGABYTE = 1024 * 1024
const MAX_VIDEO_FILE_SIZE_BYTES = 500 * BYTES_PER_MEGABYTE
const MAX_IMAGE_FILE_SIZE_BYTES = 10 * BYTES_PER_MEGABYTE

const VIDEO_EXTENSIONS = new Set(['m4v', 'mov', 'mp4', 'webm'])
const IMAGE_EXTENSIONS = new Set(['jpeg', 'jpg', 'png', 'webp'])

type ValidationConfig = {
  label: string
  maxSizeBytes: number
  maxSizeLabel: string
  extensions: Set<string>
  allowedFormatsLabel: string
}

const validateFile = (file: File, config: ValidationConfig) => {
  if (!file.size) {
    return `${config.label} file is empty`
  }

  if (file.size > config.maxSizeBytes) {
    return `${config.label} must be ${config.maxSizeLabel} or smaller`
  }

  // File.type varies by browser and operating system, so use the extension for client-side format compatibility.
  const extension = getFileExtension(file.name, '')
  const hasSupportedExtension = config.extensions.has(extension)

  if (!hasSupportedExtension) {
    return `${config.label} must be ${config.allowedFormatsLabel}`
  }

  return ''
}

export const validateVideoFile = (file: File) =>
  validateFile(file, {
    label: 'Video',
    maxSizeBytes: MAX_VIDEO_FILE_SIZE_BYTES,
    maxSizeLabel: '500 MB',
    extensions: VIDEO_EXTENSIONS,
    allowedFormatsLabel: 'an MP4, MOV, M4V, or WebM file',
  })

export const validateImageFile = (file: File) =>
  validateFile(file, {
    label: 'Image',
    maxSizeBytes: MAX_IMAGE_FILE_SIZE_BYTES,
    maxSizeLabel: '10 MB',
    extensions: IMAGE_EXTENSIONS,
    allowedFormatsLabel: 'a JPEG, PNG, or WebP file',
  })
